
export const mainbasic = {

  stafflevel: {
    service:{
      name:'stafflevel',
      title:'Staff Level',
    }
  },

  staffrole: {
    service:{
      name:'staffrole',
      title:'Staff Role',
    }
  },

  stafftype: {
    service: {
      name: 'stafftype',
      title: 'Staff Type',
    }
  },

  staffusertype: {
    service: {
      name: 'staffusertype',
      title: 'Staff User Type',
    }
  },

  staffuserstate: {
    service: {
      name: 'staffuserstate',
      title: 'Staff User State',
    }
  },

  unitcat: {
    service:{
      name:'unitcat',
      title:'Unit Category',
    }
  },

  unitclass: {
    service:{
      name:'unitclass',
      title:'Unit Class',
    }
  },

  unitgroup: {
    service:{
      name:'unitgroup',
      title:'Unit Group',
    }
  },

  unittype: {
    service:{
      name:'unittype',
      title:'Unit Type',
    }
  },

  productcategory: {
    service:{
      name:'productcateogry',
      title:'Product Category',
    }
  },

  staffplanstate: {
    service:{
      name:'staffplanstate',
      title:'Staff Plan State',
    }
  },

  branchtype: {
    service:{
      name:'branchtype',
      title:'Branch Type',
    }
  },

  notificationtype: {
    service:{
      name:'notificationtype',
      title:'Notification Type',
    }
  },

  notificationstate: {
    service:{
      name:'notificationstate',
      title:'Notification State',
    }
  },

  messagestate: {
    service:{
      name:'messagestate',
      title:'Message State',
    }
  },

};
